module.exports = __webpack_public_path__ + "static/media/backdrop-image.4050cc13.jpg";